import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { X, Lightbulb } from 'lucide-react';
export function Mechanism() {
  return <section className="w-full bg-[#FAF8FF] py-16 md:py-24 px-6" data-id="element-197">
      <div className="max-w-4xl mx-auto" data-id="element-198">
        <FadeIn data-id="element-199">
          <h2 className="text-3xl md:text-4xl font-serif text-night-900 text-center mb-10 md:mb-12 max-w-3xl mx-auto" data-id="element-200">
            La razón real por la que no puedes "simplemente relajarte"
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-12 md:mb-16" data-id="element-201">
          <FadeIn delay={0.1} data-id="element-202">
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-slate-100" data-id="element-203">
              <p className="text-base md:text-lg text-slate-700 mb-5 md:mb-6" data-id="element-204">
                La mayoría de los consejos para dormir mejor se enfocan en lo
                mismo:
              </p>
              <ul className="space-y-3 md:space-y-4" data-id="element-205">
                {['"Deja el teléfono 1 hora antes"', '"Toma tilo o melatonina"', '"Haz meditación guiada"', '"No pienses en nada"'].map((item, i) => <li key={i} className="flex items-center text-sm md:text-base text-slate-600" data-id="element-206">
                    <X className="w-4 h-4 md:w-5 md:h-5 text-red-400 mr-3 flex-shrink-0" data-id="element-207" />
                    <span className="line-through decoration-red-200" data-id="element-208">
                      {item}
                    </span>
                  </li>)}
              </ul>
              <p className="mt-5 md:mt-6 text-sm md:text-base text-slate-700 italic" data-id="element-209">
                Y sí, algunas cosas ayudan un poco... pero la mente sigue
                acelerada.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-210">
            <div className="space-y-5 md:space-y-6 text-base md:text-lg text-slate-700" data-id="element-211">
              <h3 className="text-xl md:text-2xl font-serif text-night-900 mb-3 md:mb-4" data-id="element-212">
                ¿Por qué?
              </h3>
              <p className="font-medium text-purple-900 bg-purple-100 p-4 rounded-lg" data-id="element-213">
                Porque ninguna de esas cosas resuelve el problema real: tu
                sistema nervioso no recibió la señal de que el día terminó.
              </p>
              <p data-id="element-214">
                Sin esa señal de cierre, el cerebro sigue en modo "resolver y
                proteger".
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-215">
          <div className="bg-night-900 text-white p-6 md:p-12 rounded-3xl relative overflow-hidden" data-id="element-216">
            <div className="absolute top-0 right-0 p-6 md:p-8 opacity-10" data-id="element-217">
              <Lightbulb className="w-24 h-24 md:w-32 md:h-32" data-id="element-218" />
            </div>
            <div className="relative z-10 max-w-2xl" data-id="element-219">
              <p className="text-lg md:text-2xl font-serif mb-4 md:mb-6 leading-relaxed" data-id="element-220">
                Eso es exactamente lo que hace el método Mente en Calma:
                enseñarle a tu cuerpo y mente, con señales simples y
                progresivas, que el peligro terminó.
              </p>
              <p className="text-base md:text-lg text-slate-300 mb-4 md:mb-6" data-id="element-221">
                Que puedes soltar. Que esta noche estás a salvo.
              </p>
              <p className="text-lg md:text-xl font-medium text-purple-300" data-id="element-222">
                Y lo mejor: en 7 noches, esa señal empieza a ser automática.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}